import React from 'react';
import { escapeSpecialCharacters, textMatches } from '../../api/UtilsApi';

export const getHighlightedText = (text: string, highlightWord: string) => {
  if (!highlightWord) {
    // return original text if highlightWord is empty
    return text;
  } else if (!text) {
    return '';
  }
  highlightWord = escapeSpecialCharacters(highlightWord);
  const highlightWordRegex = new RegExp(`(${highlightWord})`, 'gi'); // match all instances of highlightWord with case-insensitive
  const parts = text.split(highlightWordRegex); // split text according to highlightWord regex
  const textWithHighlight = (
    <span>
      {parts.map((part) => (
        <span key={part} className={textMatches(part, highlightWord) ? 'highlight' : 'normal'}>
          {part}
        </span>
      ))}
    </span>
  );
  return textWithHighlight;
};

export const getHighlightedHTML = (text: string, highlightWord: string) => {
  if (!highlightWord) {
    // return original text if highlightWord is empty
    return text;
  } else if (!text) {
    return '';
  }

  const highlightWordRegex = new RegExp('(' + highlightWord + ')(?!([^<]+)?>)', 'gi');

  const htmltWithHighlight = text.replace(
    highlightWordRegex,
    `<span class="fr-class-highlighted">${highlightWord}</span>`,
  );
  return htmltWithHighlight;
};
